import { createRoute } from '@tanstack/react-router';
import { adminParentRoute } from 'pages/admin/adminParentRoute';
import { pageResetMiddleWare, zodPage, zodPathParamId } from 'routes/routeUtils';
import { tradesInstanceStatus } from 'types/models';
import { z } from 'zod';

export const adminTradeRoute = createRoute({
  getParentRoute: () => adminParentRoute,
  path: '/trades/$id',
  params: z.object({ id: zodPathParamId }),
  validateSearch: z.object({
    page: zodPage,
    query: z.string().optional(),
    mode: z.enum(['instances', 'targetedPharmacies']).default('instances'),
    status: z.enum(tradesInstanceStatus).optional(),
  }),
  search: { middlewares: [pageResetMiddleWare] },
}).lazy(() => import('pages/admin/Trades/AdminTradePage/AdminTradePage').then((d) => d.Route));
